import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import {
  initialAdOverviewFilters,
  setAdOverviewActiveTab,
  setAdOverviewFilter,
  TAdOverviewTabs,
} from '../../../ad-overview/model/adOverviewSlice'
import { IAdOverviewFilter } from '../../../ad-overview/model/types/AdOverviewFilter.interface'

interface AdsCountCellProps {
  project: string
  ads_count: number
  domain: string
  country: {
    id: number
  }
  trademark: {
    name: string
  }
}

export const AdsCountCell = ({
  project,
  ads_count,
  domain,
  country,
  trademark,
}: AdsCountCellProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const linkFilters = {
    project,
    adDomain: domain,
    country: String(country.id),
    search: trademark.name,
  }
  // фильтры прошлого посещения Ad Overview не должны влиять: всё, чего нет в ссылке, по умолчанию
  const filters: IAdOverviewFilter = { ...initialAdOverviewFilters, ...linkFilters }

  return (
    <Link
      className={'cursor-pointer text-focus transition-opacity duration-150 hover:opacity-80'}
      to={`/adv-overview?${new URLSearchParams(linkFilters)}`}
      onClick={() => {
        // проект кладём в стор до перехода: иначе страны грузятся уже после монтирования селекта
        // (а из кеша — без лоадера), и BpSelect так и не показывает выбранную страну
        dispatch(setAdOverviewFilter(filters))
        dispatch(setAdOverviewActiveTab(t('pages.adOverview.ads') as TAdOverviewTabs))
      }}
    >
      {ads_count}
    </Link>
  )
}
